import { create } from 'zustand';
import socketService from '@/services/socketService';

export interface SessionState {
  // Session State
  refreshing: boolean;
  appView: boolean;

  // Socket action (delegated to socketService)
  socketEmit: (receiverId: string, emitRequest: unknown) => void;

  // App state actions
  setAppView: (appView: boolean) => void;
  setRefreshing: (refreshing: boolean) => void;
}

export const useSessionStore = create<SessionState>()(set => ({
  refreshing: false,
  appView: false,

  // ===== SOCKET ACTIONS (delegated to socketService) =====
  socketEmit: (receiverId, emitRequest) => {
    socketService.emit(receiverId, emitRequest);
  },

  // ===== APP STATE ACTIONS =====
  setAppView: appView => set({ appView }),
  setRefreshing: refreshing => set({ refreshing }),
}));

// Convenience selectors
export const useSocketEmit = () => useSessionStore(state => state.socketEmit);
export const useRefreshing = () => useSessionStore(state => state.refreshing);
export const useAppView = () => useSessionStore(state => state.appView);
